import { createSlice } from "@reduxjs/toolkit";

const SUBS_STORAGE_KEY = "subscribeDraft";

const loadDraftFromStorage = () => {
  try {
    const stored = localStorage.getItem(SUBS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    return null;
  }
};

const saveSubsDraftToStorage = (subscribeDraft) => {
  try {
    localStorage.setItem(SUBS_STORAGE_KEY, JSON.stringify(subscribeDraft));
  } catch (e) {}
};

const clearSubsDraftFromStorage = () => {
  try {
    localStorage.removeItem(SUBS_STORAGE_KEY);
  } catch (e) {}
};

const initialState = {
  subscribeDraft: loadDraftFromStorage(), // ✅ refresh survive karega
};

const SubscriptionDraftSlice = createSlice({
  name: "subscribeDraft",
  initialState,
  reducers: {
    saveSubsOrderDraft: (state, action) => {
      state.subscribeDraft = action.payload;
      saveSubsDraftToStorage(action.payload); // ✅ persist
    },
    clearSubsOrderDraft: (state) => {
      state.subscribeDraft = null;
      clearSubsDraftFromStorage(); // ✅ clear persist
    },
  },
});

export const { saveSubsOrderDraft, clearSubsOrderDraft } = SubscriptionDraftSlice.actions;

export default SubscriptionDraftSlice.reducer;
